import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSidebar } from '@contexts/SidebarContext';
import { useTheme } from '@contexts/ThemeContext';
import { Bars3Icon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { FLAT_NAV_ITEMS } from '@/config/navigation';
import { UserMenu } from './UserMenu';

export const AppHeader: React.FC = () => {
  const location = useLocation();
  const { toggleMobileSidebar } = useSidebar();
  const { theme, toggleTheme } = useTheme();

  const currentPage = FLAT_NAV_ITEMS.find((item) =>
    item.end ? location.pathname === item.to : location.pathname.startsWith(item.to)
  );

  return (
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 h-16 flex items-center px-4 gap-4 sticky top-0 z-20">
      {/* Mobile menu button */}
      <button
        onClick={toggleMobileSidebar}
        className="md:hidden p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>

      {/* Page title */}
      <div className="flex-1">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
          {currentPage?.label || 'Admin Panel'}
        </h1>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-3">
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? (
            <MoonIcon className="h-5 w-5" />
          ) : (
            <SunIcon className="h-5 w-5" />
          )}
        </button>

        <UserMenu />
      </div>
    </header>
  );
};
